import { type Team } from "@entities";
import AddIcon from "@mui/icons-material/Add";
import { Tooltip } from "@mui/material";
import { Roles } from "@shared/Roles";
import { useEffect, useState, type FC } from "react";
import { remult } from "remult";
import { useRequest } from "../../contexts/RequestProvider";
import { TeamsSelectDialog } from "../teams-select";

export const CommunitySelect: FC = () => {
  const { currentEvent: requestDetails, setCurrentEvent: setRequestDetails } =
    useRequest();
  const [teamsAnchor, setTeamsAnchor] = useState<
    (EventTarget & HTMLButtonElement) | null
  >(null);
  const [showCommunities, setShowCommunities] = useState<Team[]>([]);
  const selectedTeams = requestDetails.selectedTeams || [];

  useEffect(() => {
    setShowCommunities(selectedTeams);
  }, [selectedTeams.length]);

  function setSelectedCommunities(selected: Team[]) {
    setRequestDetails((prev) => ({
      ...prev,
      selectedTeams: selected,
    }));
  }

  return (
    <div className="teams-skills-container">
      <div className="teams-container-desktop">
        <label>שיוך לפרויקטים</label>
        <div className="items-container">
          {showCommunities.slice(0, 2).map((com) => {
            return (
              <button type="button" className="team-button" key={com.id}>
                {com.name}
              </button>
            );
          })}
          {showCommunities.length > 2 && (
            <Tooltip
              title={showCommunities
                .slice(2, showCommunities.length)
                .map((com) => com.name)
                .join(" , ")}
            >
              <p>+{showCommunities.length - 2}</p>
            </Tooltip>
          )}
        </div>
        <button
          className="add-button"
          type="button"
          onClick={(e) =>
            setTeamsAnchor((prev) => (prev ? prev : e.currentTarget))
          }
        >
          <AddIcon style={{ fontSize: "1.2rem" }} /> הוספת פרויקטים
        </button>
        <TeamsSelectDialog
          isBasicTeam={remult.isAllowed(Roles.Admins)}
          onClose={() => {
            setTeamsAnchor(null);
          }}
          onSave={(value) => {
            const teams = value as Team[];
            setShowCommunities(teams);
            setSelectedCommunities(teams);
            setTeamsAnchor(null);
          }}
          returnFullTeam
          open={!!teamsAnchor}
          value={selectedTeams}
        />
      </div>
    </div>
  );
};
